import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { CertificateTypeANPRList } from 'shell/models/certificate-type';
import { HttpResponseList } from 'shell/models/http-response';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface CertiticateTypeListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (acronym?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const CertiticateTypeListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Tipo certificato',
  id = 'certificate-type-list',
}: CertiticateTypeListComponentProps): React.ReactElement => {
  const [certificateType] = useHttpFetch<
    HttpResponseList<CertificateTypeANPRList>,
    Array<CertificateTypeANPRList>
  >(`${__CERTIFICATION_API_URL__}/certificazione/tipi-documento`, {
    onBootstrap: true,
    initialData: [],
    transformer: (response) => {
      const { data } = response;

      return data?.payload.list;
    },
  });

  const list = (certificateType.data as Array<CertificateTypeANPRList>) || [];

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item) => (
          <MenuItem
            key={`${item.key.tipoDocumento}-${item.key.codiceDocumento}`}
            value={`${item.key.tipoDocumento}-${item.key.codiceDocumento}`}
          >
            {item.descrizioneTipoDocumento}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

CertiticateTypeListComponent.displayName = 'CertiticateType List component';

const CertiticateTypeList = memo(CertiticateTypeListComponent);

export default CertiticateTypeList as typeof CertiticateTypeListComponent;
